"use client";

import ScheduleGoalsScreen from "@/components/ScheduleGoalsScreen";

interface Props {
  onNavigate: (tab: string) => void;
  autoOpenPlanToken?: number;
}

export default function PlanScreen({ onNavigate, autoOpenPlanToken = 0 }: Props) {
  return (
    <ScheduleGoalsScreen
      onNavigate={onNavigate}
      autoOpenPlanToken={autoOpenPlanToken}
    />
  );
}
